import { render, staticRenderFns } from "./BackofficeLevel.vue?vue&type=template&id=2b34cf70&"
import script from "./BackofficeLevel.vue?vue&type=script&lang=js&"
export * from "./BackofficeLevel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports